import React from "react";
import { useId } from "react";
import { useQuery } from "seed/gql";
import { Loading } from "seed/helpers";

const PermissionGridField = ({ 
  flowId, 
  fields, 
  values, 
  setFieldValue 
}) => {

  const fieldKey = useId();

  const reqRoles = useQuery(`{
    participantRoles {
      id
      name
    }
  }`, `flow.id=${flowId}`);

  if (reqRoles.loading) return <Loading />;
  if (reqRoles.error) return "Error";

  const { participantRoles = [] } = reqRoles.data;
  const permissions = participantRoles.map(role => ({
    key: role.id,
    label: role.name
  }));

  const getDefaultValue = (name) => {
    
    const keys = name.split('.');
    let value = values;
    
    for (let i = 0; i < keys.length; i++) {
      value = value[keys[i]];
      if (value == undefined)
        return permissions.reduce((acc, permission) => {
          acc[permission.key] = true;
          return acc;
        }, {});
    }

    return value;

  }

  return (
    <div className="form-group mb-4">
      <div style={{ overflowX: 'auto' }}>
        <table className="table table-sm table-borderless table-hover mb-0">
          <thead>
            <tr>
              <th style={{ position: 'sticky', left: 0, zIndex: 1 }}>
              </th>
              {permissions.map(permission => (
                <th key={fieldKey + permission.key} className="text-center px-2">
                  {permission.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {fields.map(field => (
              <tr key={fieldKey + field.name}>
                <td
                  style={{
                    position: 'sticky',
                    left: 0,
                    zIndex: 3,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {field.label}
                </td>
                {permissions.map(permission => (
                  <td key={`${fieldKey}-${field.name}-${permission.key}`} className="text-center">
                    <div className="custom-control custom-switch">
                      <input
                        type="checkbox"
                        id={`${fieldKey}-${field.name}-${permission.key}`}
                        className="custom-control-input"
                        checked={getDefaultValue(field.name)[permission.key]}
                        disabled={field.parent && !getDefaultValue(field.parent)[permission.key]}
                        onChange={() => {

                          const newValues = getDefaultValue(field.name);
                          newValues[permission.key] = !newValues[permission.key];
                          setFieldValue(field.name, newValues);

                          if (field.dependancies && newValues[permission.key] === false) {
                            field.dependancies.forEach(dep => {
                              const depValues = getDefaultValue(dep);
                              if (depValues[permission.key]) {
                                depValues[permission.key] = false;
                                setFieldValue(dep, depValues);
                              }
                            });
                          }

                        }}
                      />
                      <label className="custom-control-label" htmlFor={`${fieldKey}-${field.name}-${permission.key}`}></label>
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
  

}

export default PermissionGridField;